var render = function render(){
  var _vm$item, _vm$item2, _vm$item3, _vm$item4, _vm$item5, _vm$item6, _vm$item7, _vm$item8, _vm$item9, _vm$item0, _vm$item1, _vm$item10, _vm$item11, _vm$item12, _vm$item13;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('PageHeader', [_c('PageHeaderTitleContent', [_c('TitleTextContent', {
    attrs: {
      "titleText": 'Project Spectrum Event Details'
    }
  }), _c('router-link', {
    attrs: {
      "to": {
        name: 'events',
        query: {
          eventPage: _vm.eventPage,
          query: _vm.query,
          eventType: _vm.eventType
        }
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": '#424EC4'
    }
  }, [_vm._v(" Back to All Events ")])], 1)], 1)], 1), _c('SocialMediaWidgets', {
    attrs: {
      "title": _vm.title,
      "description": _vm.description,
      "type": 'news'
    }
  }), _c('section', {
    staticClass: "section section-blog p-0 mb-3"
  }, [_c('div', {
    staticClass: "container-fluid px-xs-3 px-sm-3 px-md-5 px-lg-5 px-xl-5 my-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "image-container"
  }, [_c('img', {
    staticClass: "image-content",
    attrs: {
      "src": (_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.cyberBannerLink,
      "alt": (_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.photoDescription
    }
  })])]), _c('div', {
    staticClass: "col-12 col-lg-6 col-xl-6"
  }, [_c('div', {
    staticClass: "event-details"
  }, [_c('div', {
    staticClass: "w-100 d-flex flex-row justify-content-start py-2 event-text event-header-text"
  }, [_vm._v(" " + _vm._s((_vm$item3 = _vm.item) === null || _vm$item3 === void 0 ? void 0 : _vm$item3.title) + " ")]), _vm.isMobile ? _c('div', {
    staticClass: "w-100 d-flex flex-row justify-content-start pb-2 event-text event-header-text"
  }, [_vm._v(" " + _vm._s(`${_vm.formatDate((_vm$item4 = _vm.item) === null || _vm$item4 === void 0 ? void 0 : _vm$item4.date)} ${_vm.formatTime((_vm$item5 = _vm.item) === null || _vm$item5 === void 0 ? void 0 : _vm$item5.date)}`) + " ")]) : _vm._e(), _c('div', {
    staticClass: "w-100 py-3 d-flex flex-column justify-content-start align-items-start event-description"
  }, [_c('span', {
    staticClass: "text-left",
    domProps: {
      "innerHTML": _vm._s((_vm$item6 = _vm.item) === null || _vm$item6 === void 0 ? void 0 : _vm$item6.article)
    }
  })]), !_vm.isMobile ? _c('div', {
    staticClass: "my-2 d-flex flex-column justify-content-start"
  }, [_c('div', {
    staticClass: "w-100 text-start event-header-text",
    staticStyle: {
      "height": "25px"
    }
  }, [_vm._v(" DATE ")]), _c('div', {
    staticClass: "w-100 text-start event-header-content",
    staticStyle: {
      "height": "25px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatDate((_vm$item7 = _vm.item) === null || _vm$item7 === void 0 ? void 0 : _vm$item7.date)) + " ")])]) : _vm._e(), !_vm.isMobile ? _c('div', {
    staticClass: "my-2 d-flex flex-column justify-content-start"
  }, [_c('div', {
    staticClass: "w-100 text-start event-header-text",
    staticStyle: {
      "height": "25px"
    }
  }, [_vm._v(" TIME ")]), _c('div', {
    staticClass: "w-100 text-start event-header-content",
    staticStyle: {
      "height": "25px"
    }
  }, [_vm._v(" " + _vm._s(_vm.formatTime((_vm$item8 = _vm.item) === null || _vm$item8 === void 0 ? void 0 : _vm$item8.date)) + " ")])]) : _vm._e()]), new Date((_vm$item9 = _vm.item) === null || _vm$item9 === void 0 ? void 0 : _vm$item9.date) <= Date.now() ? _c('div', {
    staticClass: "row my-2"
  }, [_vm.item.cyberPowerpointLink ? _c('div', {
    staticClass: "col-12 col-lg-6 col-xl-6"
  }, [_c('a', {
    staticClass: "btn theme-btn w-100 rounded centered-link",
    attrs: {
      "href": (_vm$item0 = _vm.item) === null || _vm$item0 === void 0 ? void 0 : _vm$item0.cyberPowerpointLink,
      "variant": "link",
      "target": "_blank"
    }
  }, [_vm._v(" PowerPoint ")])]) : _vm._e(), _vm.item.cyberRecordingLink ? _c('div', {
    staticClass: "col-12 col-lg-6 col-xl-6"
  }, [_c('a', {
    staticClass: "btn theme-btn w-100 rounded centered-link",
    attrs: {
      "href": (_vm$item1 = _vm.item) === null || _vm$item1 === void 0 ? void 0 : _vm$item1.cyberRecordingLink,
      "variant": "link",
      "target": "_blank"
    }
  }, [_vm._v(" Recording ")])]) : _vm._e()]) : _vm._e(), new Date((_vm$item10 = _vm.item) === null || _vm$item10 === void 0 ? void 0 : _vm$item10.date) > Date.now() ? _c('div', {
    staticClass: "row my-2"
  }, [((_vm$item11 = _vm.item) === null || _vm$item11 === void 0 ? void 0 : _vm$item11.cyberCalendarLink) != '' ? _c('div', {
    staticClass: "col-12 col-lg-6 col-xl-6"
  }, [_c('a', {
    staticClass: "btn theme-btn w-100 rounded centered-link",
    attrs: {
      "href": (_vm$item12 = _vm.item) === null || _vm$item12 === void 0 ? void 0 : _vm$item12.cyberCalendarLink,
      "variant": "link",
      "target": "_blank"
    }
  }, [_vm._v(" Register ")])]) : _vm._e(), _vm.item.cyberCalendarLink === '' ? _c('div', {
    staticClass: "col-12 col-lg-6 col-xl-6"
  }, [_c('a', {
    staticClass: "btn theme-btn w-100 rounded centered-link disabled",
    attrs: {
      "href": (_vm$item13 = _vm.item) === null || _vm$item13 === void 0 ? void 0 : _vm$item13.cyberCalendarLink,
      "variant": "link",
      "target": "_blank"
    }
  }, [_vm._v(" Calender ")])]) : _vm._e()]) : _vm._e()])])])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }